import { render, staticRenderFns } from "./NewClientContact.vue?vue&type=template&id=245533b7&scoped=true&"
import script from "./NewClientContact.vue?vue&type=script&lang=js&"
export * from "./NewClientContact.vue?vue&type=script&lang=js&"
import style0 from "./NewClientContact.vue?vue&type=style&index=0&id=245533b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245533b7",
  null
  
)

export default component.exports